import { Config } from './types';

export const stagingUrl: Config = {
  API_URL: 'https://pallexpesantisrl.com',
};
